export default __webpack_public_path__ + "static/Image004-b6052deea0daf7a35c146e3a843be0e2.jpg";